import React from 'react';
import { properties } from './properties';

export function LoginRedirectDialogBox() {
    
    function redirectToLogin() {
        window.location.href = window.location.pathname;
    }

    return (
        <>
            <div className="login-modal" id="loginModal">
                <div className="login-dialog-box">
                    <div className="login-dialog-box-inner">
                        <p>{properties.MESSAGE_LIST.LOGOUT_MSG}</p>
                        <div className="login-btn-container">
                            <button type="button" className="login-btn" onClick={redirectToLogin}>Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}